import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

interface service {
    name: string,
    api: string,
}

@Component
/**
 * ProfileTransactions Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Title of the Panel
     */
    @Prop() title!: string;

    /**
     * User Metadata
     */
    @Prop() userMetadata!: {[k: string]: any};

    /**
     * Fetch transactions Service
     */
    @Prop({ default: () => ({ name: 'Payment', api: 'userTransactions' }) }) fetchTransactionsService!: service;

    /**
     * Filters
     */
    @Prop({ default: () => (['all', 'paid', 'received']) }) filters!: Array<string>;
}
